<div class="home-card">
    <div class="title">
        <h3>{{ 'home.widgetInfo.' + behavior + '.title' | translate }}</h3>
    </div>

    <div>
        <p class="bold-info">{{ value }}</p>

        <ng-container *ngIf="behavior === 'notification'">
            <button
                class="btn btn-secondary"
                (click)="goTo('clubs')"
                *ngIf="value <= 0"
                [appTrack]="'homepage_discussions_clicked'"
                [appTrackParams]="{ next_step: 'view_clubs' }"
            >
                {{ 'home.widgetInfo.notification.CTALabelNull' | translate }}
            </button>

            <button
                class="btn btn-secondary"
                (click)="notificationDrawer.openDrawer()"
                *ngIf="value > 0"
                [appTrack]="'homepage_discussions_clicked'"
                [appTrackParams]="{ next_step: 'open_drawer' }"
            >
                {{ 'home.widgetInfo.notification.CTALabel' | translate }}
            </button>

            <app-drawer-notification #notificationDrawer (notificationsCount)="onReceiveValue($event)"></app-drawer-notification>
        </ng-container>

        <div class="dropdown" *ngIf="value <= 0 && behavior === 'registration'">
            <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" (click)="openDrawer()">
                {{ 'home.widgetInfo.registration.CTALabelNull' | translate }}
            </button>
            <div class="dropdown-menu">
                <a
                    class="dropdown-item"
                    [appTrack]="'homepage_registrations_clicked'"
                    [appTrackParams]="{ next_step: 'view_projects' }"
                    (click)="goTo('projects')"
                    >{{ 'home.widgetInfo.registration.DropdownProjects' | translate }}</a
                >
                <a
                    class="dropdown-item"
                    [appTrack]="'homepage_registrations_clicked'"
                    [appTrackParams]="{ next_step: 'view_events' }"
                    (click)="goTo('events')"
                    >{{ 'home.widgetInfo.registration.DropdownEvents' | translate }}</a
                >
            </div>
        </div>

        <button
            class="btn btn-secondary"
            [appTrack]="'homepage_registrations_clicked'"
            [appTrackParams]="{ next_step: 'open_drawer' }"
            (click)="openDrawer()"
            *ngIf="value > 0 && behavior === 'registration'"
        >
            {{ 'home.widgetInfo.registration.CTALabel' | translate }}
        </button>
    </div>
</div>
